import { render, staticRenderFns } from "./MyOverlayCard.vue?vue&type=template&id=0007c224&scoped=true"
import script from "./MyOverlayCard.vue?vue&type=script&lang=js"
export * from "./MyOverlayCard.vue?vue&type=script&lang=js"
import style0 from "./MyOverlayCard.vue?vue&type=style&index=0&id=0007c224&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007c224",
  null
  
)

export default component.exports